import { LINK_OF_ALL_PAGES } from "const/common";
import { OUR_SOLUTION_CARD_DATA_SOLUTION_DATA } from "const/data-solution";
import dynamic from "next/dynamic";
import PrimaryButton from "../common/PrimaryButton";

const Container = dynamic(() => import("@/components/common/Container"));
const Title = dynamic(() => import("../common/Title"));
const ComponyOffer = dynamic(() => import("./common/ComponyOffer"));

const WeOffer = () => (
  <Container large className="bg-primary-black">
    <Title
      description="Dive into the forefront of innovation with ultroNeous. Our array of solutions includes diverse
proxies, Scraper APIs, and advanced tools, guaranteeing seamless website access and
unrivaled capabilities."
      descriptionClass="text-base text-white text-center font-light md:font-normal pb-10 md:pb-24 md:px-64"
      subTitle="What We Offer"
      subTitleClass="text-4xl md:text-6xl text-white text-center mb-6 xl:pb-2"
    />
    <ComponyOffer data={OUR_SOLUTION_CARD_DATA_SOLUTION_DATA} />
    <div className="flex justify-center pb-36 md:pb-40 pt-10 md:pt-20">
      <PrimaryButton link={LINK_OF_ALL_PAGES.mainPages.contactUs} val="Contact Us Now!" />
    </div>
  </Container>
);

export default WeOffer;
